import { EnvironmentConfig } from "../models/environment-config.model";

export const environment: EnvironmentConfig = {
  production: false,
  envName: 'dev',
  apiBaseURL: 'https://search-copilot-h4d3cwa8c6eubphu.westeurope-01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '4f1bc601-4e03-4f46-9e54-9fa615c81bcb',
      authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
      redirect_uri: 'https://search-copilot-dev.cs.ms.hcvpc.io/login/callback',
    },
  },
  apiConfig: {
    scopes: ['User.Read', 'email', 'profile'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
};
